"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// https://github.com/nfriend/ts-key-enum
var EventKey;
(function (EventKey) {
    /** The Enter or ↵ key (sometimes labeled Return). */
    EventKey["Enter"] = "Enter";
    EventKey["Escape"] = "Escape";
    EventKey["Shift"] = "shiftKey";
    EventKey["Space"] = "Space";
    EventKey["Tab"] = "Tab";
    EventKey["X"] = "x";
    EventKey["Backspace"] = "Backspace";
    EventKey["ArrowUp"] = "ArrowUp";
    EventKey["ArrowDown"] = "ArrowDown";
    EventKey["ArrowLeft"] = "ArrowLeft";
    EventKey["ArrowRight"] = "ArrowRight";
})(EventKey || (EventKey = {}));
exports.default = EventKey;
